<template>
  <div id="header">
    <van-dropdown-menu>
      <van-dropdown-item v-model="projectId" :options="rolePorjectList" @change="onProjectId" />
      <van-dropdown-item v-model="projectFlag" :options="projectFlagList" @change="onProjectFlag" />
    </van-dropdown-menu>
  </div>
</template>
<script>
import { Toast } from "vant";
import { getUserInfo } from "@/api/mine/mine";
import { roleAllProject } from "@/api/common/common";
import { getChangeProject } from "@/api/home/home";
export default {
  data() {
    return {
      projectId: "",
      rolePorjectList: [],
      projectFlag: window.sessionStorage.getItem('projectFlag') ? window.sessionStorage.getItem('projectFlag') === "true" : false,
      projectFlagList: [
        { text: '商办业务', value: false },
        { text: '公寓业务', value: true },
      ]
    };
  },
  created() {
    this.roleAllProject();
    this.getUserInfo();
  },
  methods: {
    // 【请求】当前权限可选园区列表
    roleAllProject() {
      roleAllProject().then(res => {
        if (res.success && res.list) {
          this.rolePorjectList = [
            {
              text: "全部园区",
              value: ""
            },
            ...JSON.parse(JSON.stringify(res.list).replace(/projectName/g, "text").replace(/projectId/g, "value"))
          ]
        }
      })
    },

    // 【请求】用户信息
    getUserInfo() {
      getUserInfo().then((res) => {
        if (res.success && res.data) {
          let selectedProjectIdSet = res.data.selectedProjectIdSet;
          if (selectedProjectIdSet.length == 1) {
            this.projectId = selectedProjectIdSet[0]
          } else {
            this.projectId = ""
          }
        }
      });
    },

    // 【监听】园区选择
    onProjectId() {
      let data = {
        viewMode: "1",
        selectedProjectIdSet: this.projectId ? [this.projectId] : [],
        selectedUnitIdSet: [],
      };
      getChangeProject(data).then((res) => {
        if (res.success) {
          window.location.reload();
        }
      });
    },

    // 【监听】业务类型选择
    onProjectFlag() {
      window.sessionStorage.setItem('projectFlag', this.projectFlag);
      window.location.reload();
    }
  },
};
</script>

<style lang="scss">
@import "~@/assets/styles/theme";

#header {
  height: 0.46rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: $theme-color;


  // 下拉选项
  .van-dropdown-menu {
    height: 100%;
    width: 100%;
  }

  .van-dropdown-menu__bar {
    background-color: $theme-color !important;
    height: 100%;

    .van-dropdown-menu__title {
      color: #fff;
    }

  }

  .van-dropdown-item__option--active {
    color: $theme-color ;
  }

  // 切换角色
  .van-icon {
    color: #fff;
  }
}
</style>